// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___qYvqr","commentIcon":"index-module__commentIcon___xwlK0","commentBox":"index-module__commentBox___3dW4Q"};